var React = require('react');

function Columns (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 1.5A1.5 1.5 0 011.5 0h9A1.5 1.5 0 0112 1.5v45a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 010 46.5v-45zM3 3v42h6V3H3zm15.002-1.5a1.5 1.5 0 011.5-1.5h9a1.5 1.5 0 011.5 1.5v45a1.5 1.5 0 01-1.5 1.5h-9a1.5 1.5 0 01-1.5-1.5v-45zm3 1.5v42h6V3h-6zM36 1.5A1.5 1.5 0 0137.5 0h9A1.5 1.5 0 0148 1.5v45a1.5 1.5 0 01-1.5 1.5h-9a1.5 1.5 0 01-1.5-1.5v-45zM39 3v42h6V3h-6z"}));
}

Columns.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Columns;

Columns.default = Columns;
